import React, { useState, useRef, useEffect } from 'react';
import { useLang, LANGUAGES } from '../i18n';

export default function LanguageSwitcher() {
  const { lang, setLang } = useLang();
  const [open, setOpen] = useState(false);
  const ref = useRef();
  const current = LANGUAGES.find(l => l.code === lang) || LANGUAGES[0];

  useEffect(() => {
    const h = e => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <button
        onClick={() => setOpen(v => !v)}
        style={{
          display: 'flex', alignItems: 'center', gap: 5,
          background: 'none', border: '1px solid var(--border)',
          borderRadius: 8, padding: '5px 10px', cursor: 'pointer',
          color: 'var(--text)', fontSize: 12, fontWeight: 600,
          transition: 'border-color .15s',
        }}
        onMouseEnter={e => e.currentTarget.style.borderColor = 'var(--primary)'}
        onMouseLeave={e => e.currentTarget.style.borderColor = 'var(--border)'}
      >
        <span style={{ fontSize: 14 }}>{current.flag}</span>
        <span>{current.nativeLabel}</span>
        <span style={{ fontSize: 10, color: 'var(--td)', marginLeft: 2 }}>▾</span>
      </button>

      {open && (
        <div style={{
          position: 'absolute', top: 'calc(100% + 6px)', right: 0, zIndex: 9999,
          background: 'var(--surface)', border: '1px solid var(--border)',
          borderRadius: 10, boxShadow: '0 8px 24px rgba(0,0,0,.2)',
          minWidth: 150, overflow: 'hidden',
        }}>
          {LANGUAGES.map(l => (
            <button
              key={l.code}
              onClick={() => { setLang(l.code); setOpen(false); }}
              style={{
                display: 'flex', alignItems: 'center', gap: 10,
                width: '100%', padding: '10px 14px',
                background: lang === l.code ? 'var(--pm)' : 'transparent',
                border: 'none', cursor: 'pointer', textAlign: 'left',
                color: lang === l.code ? 'var(--primary)' : 'var(--text)',
                fontSize: 13, fontWeight: lang === l.code ? 700 : 400,
              }}
              onMouseEnter={e => { if (lang !== l.code) e.currentTarget.style.background = 'var(--s2)'; }}
              onMouseLeave={e => { if (lang !== l.code) e.currentTarget.style.background = 'transparent'; }}
            >
              <span style={{ fontSize: 18 }}>{l.flag}</span>
              <div>
                <div style={{ fontWeight: 700, fontSize: 13 }}>{l.nativeLabel}</div>
                <div style={{ fontSize: 11, color: 'var(--td)' }}>{l.label}</div>
              </div>
              {lang === l.code && (
                <span style={{ marginLeft: 'auto', color: 'var(--primary)', fontSize: 14 }}>✓</span>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
